import clsx from 'clsx';
import React from 'react';

import { TextInput } from '../Input/TextInput';

type Props = Parameters<typeof TextInput>[0];

export const ModalTextInput = React.forwardRef<HTMLInputElement, Props>(
  (
    { disabled, readOnly, className, 'data-testid': dataTestId, ...props },
    ref
  ) => (
    <TextInput
      ref={ref}
      size="md"
      border={props.border ?? false}
      height="h-full"
      width={props.width ?? 'w-full'}
      padding="p-f0"
      background="bg-main-200"
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      className={clsx(
        'text-ellipsis',
        // eslint-disable-next-line no-nested-ternary -- disabled / readOnly / editable
        disabled
          ? 'hover:cursor-disabled hover:bg-main-200'
          : readOnly
          ? 'cursor-default hover:bg-main-200'
          : 'hover:cursor-text hover:bg-negative',
        'text-f2',
        props.border && 'border-main-300 border-[0.5px]',
        className
      )}
      data-lpignore
      data-1p-ignore
      data-form-type="other"
      data-testid={dataTestId}
    />
  )
);

ModalTextInput.displayName = 'ModalTextInput';
